/* Globals*/
const body = document.body;

function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function closeSubNav() {
  const topLevelNavItems = document.querySelectorAll(".header__nav-top-level");
  topLevelNavItems.forEach((topLevelItems) => {
    topLevelItems.classList.remove("header__nav-top-level--open");
  });

  // Keep ARIA state in sync: mark every expandable trigger as collapsed
  document.querySelectorAll('.header__nav-top-level-parent[aria-controls]').forEach((parent) => {
    parent.setAttribute('aria-expanded', 'false');
  });

  headerNav.classList.remove('header__nav-sub-level--open')

  const subNavColumnsOpen = document.querySelectorAll('.header-nav__column.sub-nav--open');
  subNavColumnsOpen.forEach((subNavColumnOpen) => {
    subNavColumnOpen 
      ? subNavColumnOpen.classList.remove('sub-nav--open') 
      : '';
  })

}

function toggleMobileMenu() {
  // Toggle mobile menu class
  const mobileNav = document.querySelector(".header__nav");
  mobileNav.classList.contains("header__nav--open")
    ? mobileNav.classList.remove("header__nav--open")
    : mobileNav.classList.add("header__nav--open");

  // Toggle body class
  const body = document.body;
  body.classList.contains("body--header-open")
    ? body.classList.remove("body--header-open")
    : body.classList.add("body--header-open");
}

// Click event to toggle subnav
const headerNav = document.querySelector(".header__nav");

// Desktop
const navTopLevel = document.querySelectorAll(".header__nav-top-level");
navTopLevel.forEach((topLevelNavItem) => {

  // Open on hover
  topLevelNavItem.addEventListener("mouseenter", () => {
    if (window.innerWidth > 1024) {
      headerNav.classList.add("header__nav--open");
      topLevelNavItem.closest('.header__nav-top-level').classList.add("header__nav-top-level--open");
      const parentTrigger = topLevelNavItem.querySelector('.header__nav-top-level-parent');
      if (parentTrigger) parentTrigger.setAttribute('aria-expanded', 'true');

      body.classList.contains("body--header-open")
      ? ''
      : body.classList.add("body--header-open");
    }
  });

  // Close when leaving
  topLevelNavItem.addEventListener("mouseleave", () => {
    if (window.innerWidth > 1024) {
      headerNav.classList.remove("header__nav--open");

      body.classList.contains("body--header-open")
      ? body.classList.remove("body--header-open")
      : '';
      closeSubNav();
    }
  });
});

// Mobile
const topLevelNavItems = document.querySelectorAll(".header__nav-top-level-parent");
topLevelNavItems.forEach((topLevelNavItem) => {
  // Toggle on activation (click / Enter / Space). The trigger is a <button>, so
  // keyboard activation fires a native click. Focus alone never opens the menu.
  topLevelNavItem.addEventListener("click", (event) => {
    event.preventDefault();
    const itemLi = topLevelNavItem.closest('.header__nav-top-level');
    if (!itemLi) return;

    if (window.innerWidth <= 1024) {
      // Mobile: toggle this column's open state
      const willOpen = !itemLi.classList.contains("header__nav-top-level--open");
      itemLi.classList.toggle("header__nav-top-level--open", willOpen);
      topLevelNavItem.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      headerNav.classList.toggle('header__nav-sub-level--open');
    } else {
      // Desktop: disclosure toggle
      const isOpen = itemLi.classList.contains("header__nav-top-level--open");
      if (isOpen) {
        closeSubNav();
        headerNav.classList.remove("header__nav--open");
        body.classList.remove("body--header-open");
      } else {
        closeSubNav(); // collapse any other open panel first
        headerNav.classList.add("header__nav--open");
        itemLi.classList.add("header__nav-top-level--open");
        topLevelNavItem.setAttribute('aria-expanded', 'true');
        body.classList.add("body--header-open");
      }
    }
  });

  // Focus does NOT open the menu. Moving focus to a different top-level trigger
  // collapses any panel that is open elsewhere, keeping a single open context.
  topLevelNavItem.addEventListener("focusin", () => {
    if (window.innerWidth <= 1024) return;
    const openItem = document.querySelector('.header__nav-top-level--open');
    if (openItem && !openItem.contains(topLevelNavItem)) {
      closeSubNav();
      headerNav.classList.remove("header__nav--open");
      body.classList.remove("body--header-open");
    }
  });
});

// Sub Nav Mobile Menu
const subNavTopLevelItems = document.querySelectorAll('.header__sub-nav-head');
subNavTopLevelItems.forEach((subNavTopLevelItem) => {
  subNavTopLevelItem.addEventListener('click', (event) => {
    if (window.innerWidth <= 1024) {
      event.preventDefault();
      const subNavClicked = event.target;
      const subNavColumn = subNavClicked.closest('.header-nav__column');

      if (subNavColumn.classList.contains('sub-nav--open')) {
        subNavColumn.classList.remove('sub-nav--open') 
      } else {
        subNavColumn.classList.add('sub-nav--open');
      }
    }
  });
});

// Keyboard focus out 
const mainNavItems = document.querySelectorAll('.header__nav-top-level-link');
mainNavItems.forEach((mainNavItem) => {
  // Close when leaving
  mainNavItem.addEventListener("focusin", () => {
    if (window.innerWidth > 1024) {
      headerNav.classList.remove("header__nav--open");

      body.classList.contains("body--header-open")
      ? body.classList.remove("body--header-open")
      : '';
      closeSubNav();
    }
  });
})

// Keyboard dismissal of the desktop mega-menu
const trellisNavEl = document.querySelector('.trellis-navigation');
if (trellisNavEl) {
  // Escape closes the open panel and returns focus to its trigger
  trellisNavEl.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    if (window.innerWidth <= 1024) return;

    const openItem = document.querySelector('.header__nav-top-level--open');
    if (!openItem) return;

    const trigger = openItem.querySelector('.header__nav-top-level-parent');
    closeSubNav();
    headerNav.classList.remove('header__nav--open');
    body.classList.remove('body--header-open');

    // Return focus to the trigger that opened the panel
    if (trigger) trigger.focus();
  });

  // Close the menu when keyboard focus leaves the navigation entirely
  trellisNavEl.addEventListener('focusout', (event) => {
    if (window.innerWidth <= 1024) return;
    if (!trellisNavEl.contains(event.relatedTarget)) {
      closeSubNav();
      headerNav.classList.remove('header__nav--open');
      body.classList.remove('body--header-open');
    }
  });
}

// Mobile main menu
const mainMenu = document.querySelector('.header-nav__main-menu-button');
mainMenu.addEventListener('click', (event) => {
  closeSubNav();
});

// Open mobile menu
const mobileMenuToggle = document.querySelector(".trellis-navigation__hamburger-menu");
mobileMenuToggle.addEventListener("click", () => {
  mobileMenuToggle.classList.contains("header__hamburger--open")
    ? mobileMenuToggle.classList.remove("header__hamburger--open")
    : mobileMenuToggle.classList.add("header__hamburger--open");

  toggleMobileMenu();
  closeSubNav();
});

// Populate mobile call 
const phoneNum = document.querySelector('.trellis-utility-nav__phone');
if (phoneNum) {
  const mobilePhone = document.querySelector('.header__phone');
  mobilePhone.textContent = phoneNum.textContent;
  mobilePhone.setAttribute('href', phoneNum.getAttribute('href'));
}

// Mobile Search trigger
const searchTrigger = document.querySelector('.trellis-navigation__search-trigger');
const searchInput = document.querySelector('.trellis-navigation .search__input');
const navigation = document.querySelector('.trellis-navigation');

searchTrigger.addEventListener('click', (trigger) => {
  navigation.classList.toggle('search--open')
  document.body.classList.toggle('search--open-overflow-hidden')
});

if (searchInput) {
  searchInput.addEventListener('focusin', () => {
    const klevuContainer = document.querySelector('.kuQuickSearchAutoCompleteLayout');
    // Only add class if the Quick Search is not visible
    if (klevuContainer) {
      window.dispatchEvent(new Event('resize'));
      if (klevuContainer.style.display === 'block') {
       document.body.classList.add('search--open-overflow-hidden')
      }
    }
  });

  // Focus on search results when tabbing from search input
  searchInput.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      const klevuContainer = document.querySelector('.kuQuickSearchAutoCompleteLayout');
      const hasPopularSearches = klevuContainer.querySelector('.kuPopularSearchTerm a');
      const hasSuggestedSearches = klevuContainer.querySelector('.klevuAutosuggestions ul li a');
      const noResultsPopular = klevuContainer.querySelector('.klevuQuickSearchNoResultsPopular ul li a');

      // If input has no value then focus on first popular search link
      if (hasPopularSearches) {
        hasPopularSearches.focus();
      }

      // If input has value and there are results focus on suggestion link
      if (hasSuggestedSearches) {
        hasSuggestedSearches.focus();
      }

      // If no results then focus on first popular product
      if (!hasPopularSearches && noResultsPopular) {
        noResultsPopular.focus();
      }
    }
  });
}

// Focus on input if first tabable link in results currently has focus
document.body.addEventListener('keydown', (event) => {
  if (event.key === 'Tab' && event.shiftKey) {
    const klevuContainer = document.querySelector('.kuQuickSearchAutoCompleteLayout');
    const elementWithFocus = document.activeElement
    const firstPopularTerm = klevuContainer.querySelector('.kuPopularSearchTerm a');
    const firstSuggestedSearches = klevuContainer.querySelector('.klevuAutosuggestions ul li a');
    const noResultsPopular = klevuContainer.querySelector('.klevuQuickSearchNoResultsPopular ul li a');

    // If first popular search, or first suggested search, or first no results popular product has focus (appears when search input is blank) return focus to search input
    if (elementWithFocus === firstPopularTerm || elementWithFocus === firstSuggestedSearches || elementWithFocus === noResultsPopular) {
      event.preventDefault();
      searchInput.focus();
    }
  };
});

// If last element in klevu container has focus, add focus to element after seach input when tabbing
document.addEventListener('focus', function () {
  const klevuResults = document.querySelector('.kuQuickSearchAutoCompleteLayout');
  const elementWithFocus = document.activeElement;

  if (klevuResults.contains(elementWithFocus)) {
    const links = klevuResults.querySelectorAll('a');

    // Check if the last link has focus
    const lastLink = links[links.length - 1];

    lastLink.addEventListener('keydown', (event) => {
      if (event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault();
        const nextFocusElement = document.querySelector('.search__button.field__button');

        document.body.click();
        nextFocusElement.focus();
      }
    })
  }
}, true);

// Klevu search off click 
document.addEventListener('click', (event) => {
  const target = event.target;
  if (target.matches('.kuQuickSearchAutoCompleteLayout .klevuWrap')) {
    document.body.classList.remove('search--open-overflow-hidden')
  }
    //window.dispatchEvent(new Event('resize'));
});

// Close mobile menu if it's open on desktop
const checkDeviceType = debounce(function () {
  if (
    mobileMenuToggle.classList.contains("header__hamburger--open") &&
    window.innerWidth > 1024
  ) {
    mobileMenuToggle.classList.remove("header__hamburger--open");

    toggleMobileMenu();
  }

  // Needed to do document.querySelector due to race conditions
  const klevuContainer = document.querySelector('.kuQuickSearchAutoCompleteLayout');
  if (klevuContainer) {
    if (klevuContainer.style.display === 'block') {
      navigation.classList.add('search--open')
      document.body.classList.add('search--open-overflow-hidden')
    } else {
      navigation.classList.remove('search--open')
      document.body.classList.remove('search--open-overflow-hidden')
    }
  }
}, 250);

// Check if sub-nav has multiple children with the class 'header-nav__column--has-children', add 'header-nav__sub-nav--multi-child' class if true
const subNavs = document.querySelectorAll('.header-nav__sub-nav');
subNavs.forEach(subNav => {
  const withChildren = subNav.querySelectorAll('.header-nav__column--has-children')
  
  if (withChildren.length > 1) {
    subNav.classList.add('header-nav__sub-nav--multi-child');
  }
});

window.addEventListener("resize", checkDeviceType);
